import React from "react";

function TermsOfService() {
  return (
    <div className="container">
      <div className="mt-5 mx-3">
        <h1>Terms of Service</h1>
        <p>
          <strong>Effective Date:</strong> [15/01/2026]
        </p>
        <p>
          Welcome to our PDF editing tool website ("Service", "we", "our", or
          "us"). By accessing or using our Service, you agree to be bound by
          these Terms of Service. If you do not agree, please discontinue use of
          the Service.
        </p>
        <h2>1. Description of Service</h2>
        <p>
          Our Service provides tools to edit PDF files, including but not
          limited to PDF compression, conversion, merging, splitting,
          watermarking, and related document-processing features. Some features
          may require account creation.
        </p>
        <h2>2. Eligibility</h2>
        <p>
          You must be at least 13 years old to use the Service. By using the
          Service, you confirm that you meet this requirement and have the legal
          capacity to enter into these Terms.
        </p>
        <h2>3. Account Registration</h2>
        <p>
          Certain features may require you to create an account. You agree to
          provide accurate and complete information and to keep your credentials
          secure. You are responsible for all activities that occur under your
          account.
        </p>
        <h2>4. User Responsibilities</h2>
        <ul>
          <li>Upload only content you have the legal right to use</li>
          <li>Do not upload malware, viruses, or harmful code</li>
          <li>Do not use the Service for unlawful or abusive purposes</li>
          <li>
            Do not attempt to interfere with Service security or performance
          </li>
        </ul>
        <p>
          You are solely responsible for the content you upload and process
          using the Service.
        </p>
        <h2>5. File Handling and Data Processing</h2>
        <p>
          Uploaded files are processed only to perform the requested PDF
          operation. Files are automatically deleted after processing or within
          a short predefined period. For offline tools, all processing occurs
          locally on your device and files never leave your system.
        </p>
        <h2>6. Legal Basis for Processing (GDPR)</h2>
        <ul>
          <li>Your consent</li>
          <li>Performance of a contract to provide the Service</li>
          <li>Legitimate interests such as security and service improvement</li>
          <li>Compliance with legal obligations</li>
        </ul>
        <h2>7. Privacy Rights (GDPR &amp; CCPA)</h2>
        <p>
          We process personal data in accordance with applicable data protection
          laws, including GDPR and CCPA. For full details, please review our
          Privacy Policy.
        </p>
        <h3>GDPR Rights (EEA Residents)</h3>
        <ul>
          <li>Access your personal data</li>
          <li>Request correction or deletion</li>
          <li>Restrict or object to processing</li>
          <li>Withdraw consent at any time</li>
          <li>Request data portability</li>
          <li>Lodge a complaint with a supervisory authority</li>
        </ul>
        <h3>CCPA Rights (California Residents)</h3>
        <ul>
          <li>Know what personal information is collected</li>
          <li>Request deletion of personal information</li>
          <li>Opt out of the sale or sharing of personal information</li>
          <li>Non-discrimination for exercising privacy rights</li>
        </ul>
        <p>
          We do not sell or share personal information as defined under CCPA.
        </p>
        <h2>8. Authorized Agent Requests (CCPA)</h2>
        <p>
          California residents may designate an authorized agent to submit
          privacy requests on their behalf. We may require verification of
          identity and authorization before processing such requests.
        </p>
        <h2>9. Data Retention</h2>
        <p>
          We retain personal information only for as long as necessary to
          fulfill the purposes described in these Terms, maintain account
          functionality, comply with legal obligations, and resolve disputes.
        </p>
        <h2>10. Intellectual Property</h2>
        <p>
          All content, software, branding, and functionality of the Service are
          owned by or licensed to us and protected by intellectual property
          laws. You may not copy, modify, distribute, or reverse engineer any
          part of the Service without written permission.
        </p>
        <h2>11. Service Availability</h2>
        <p>
          We strive to keep the Service available but do not guarantee
          uninterrupted or error-free operation. We may modify, suspend, or
          discontinue any part of the Service at any time.
        </p>
        <h2>12. Third-Party Services</h2>
        <p>
          The Service may rely on third-party services such as analytics or
          authentication providers. We are not responsible for third-party
          services or their practices.
        </p>
        <h2>13. Disclaimer of Warranties</h2>
        <p>
          The Service is provided on an "as is" and "as available" basis without
          warranties of any kind. We do not guarantee accuracy, reliability, or
          suitability for any purpose.
        </p>
        <h2>14. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, we shall not be liable for any
          indirect, incidental, or consequential damages arising from your use
          of the Service.
        </p>
        <h2>15. Termination</h2>
        <p>
          We may suspend or terminate access to the Service if you violate these
          Terms. You may stop using the Service at any time.
        </p>
        <h2>16. Changes to These Terms</h2>
        <p>
          We may update these Terms from time to time. Changes will be posted on
          this page and take effect immediately upon publication. Continued use
          of the Service constitutes acceptance of the updated Terms.
        </p>
        <h2>17. Governing Law</h2>
        <p>
          These Terms shall be governed by and interpreted in accordance with
          applicable laws, without regard to conflict of law principles.
        </p>
        <h2>18. Contact Information</h2>
        <p>
          If you have questions about these Terms or wish to exercise your
          privacy rights, please contact us through our website.
        </p>
      </div>
    </div>
  );
}

export default TermsOfService;
